export enum TypAvSnittkurs {
  DAGSKURS = 'DAGSKURS',
  GENOMSNITT_MANAD = 'GENOMSNITT_MANAD',
  GENOMSNITT_AR = 'GENOMSNITT_AR'
}
